import React, { useMemo, useState } from 'react';
import { Checkbox, FlexContainer } from 'common/components/atoms';
import Modal from 'common/components/organisms/Modal';
import { humanize } from 'common/helpers';
import { ColumnIcon } from 'common/images/FaIcons';
import { useTranslation } from 'react-i18next';


function EditDropdown({
  allColumns,
  selectedColumns,
  toggleColumn,
  title,
  labelKeyPrefix,
  renderTrigger,
}) {
  const { t } = useTranslation();
  const [showColumnEditor, setShowColumnEditor] = useState(false);
  const modalTitle = title || t('sensors.editDropdown.selectDeviceColumnsTitle');

  const labelForColumn = useMemo(() => {
    if (!labelKeyPrefix) return column => humanize(column);
    return column => t(`${labelKeyPrefix}.${column}`, { defaultValue: humanize(column) });
  }, [labelKeyPrefix, t]);

  const openEditor = () => setShowColumnEditor(true);

  return (
    <div>
      {renderTrigger ? (
        renderTrigger(openEditor)
      ) : (
        <span style={{ cursor: 'pointer' }} onClick={openEditor}>
          <ColumnIcon />
        </span>
      )}
      {showColumnEditor && (
        <Modal
          title={modalTitle}
          padding="0"
          outerPadding="0"
          headerPadding="1rem"
          headerRadius="5px"
          width="30rem"
          close={() => setShowColumnEditor(false)}
          showHeaderBorder
        >
          <FlexContainer direction="column" margin="1rem">
            {allColumns.map(column => (
              <FlexContainer key={column} alignItems="center" padding="10px" onClick={() => toggleColumn(column)}>
                <Checkbox value={selectedColumns.includes(column)} />
                <span style={{ marginLeft: '10px' }}>{labelForColumn(column)}</span>
              </FlexContainer>
            ))}
          </FlexContainer>
        </Modal>
      )}
    </div>
  );
}

export default EditDropdown;
